export const employeesConstants = {
  EMPLOYEES_REQUEST: "EMPLOYEES_REQUEST",
  EMPLOYEES_SUCCESS: "EMPLOYEES_SUCCESS",
  EMPLOYEES_FAILURE: "EMPLOYEES_FAILURE",
  EMPLOYEES_RESET: "EMPLOYEES_RESET",
  EMPLOYEES_UPDATE_ONE: "EMPLOYEES_UPDATE_ONE",
  EMPLOYEES_RESET_UPDATE: "EMPLOYEES_RESET_UPDATE",
};
